@use "variables" as *;

.name {
  font-size: $fontSize-m;
  white-space: pre-wrap;
  text-align: center;
  margin: $spacing-s;
}

.skeleton {
  width: 100%;
  border-radius: 20px;
}
